import { useState, useCallback } from "react";
import { toast } from "sonner";
import { useGlobalContext } from "../../GlobalContext";

export default function useVolunteerCharges() {
  const { api, AdminId } = useGlobalContext();

  const [volunteerCharges, setVolunteerCharges] = useState([]);
  const [volunteerChargesLoading, setVolunteerChargesLoading] = useState(false);

  const shouldShowLocalError = (data) => {
    return (
      data?.responseCode !== "00" &&
      data?.responseCode !== "02" &&
      data?.responseCode !== "03" &&
      data?.responseCode !== "98" &&
      data?.responseCode !== "401"
    );
  };

  const getVolunteerUserId = () => {
    try {
      const volunteerData = JSON.parse(
        sessionStorage.getItem("volunteerData") || "{}"
      );

      return String(
        volunteerData?.userId ||
          volunteerData?.userid ||
          volunteerData?.id ||
          AdminId ||
          ""
      );
    } catch (error) {
      return String(AdminId || "");
    }
  };

  /* ---------------- ADD VOLUNTEER CHARGES ---------------- */

  const addVolunteerChargesApi = async (payload = {}, onSuccess) => {
    setVolunteerChargesLoading(true);

    try {
      const body = {
        adminId: String(payload?.adminId || getVolunteerUserId()),
        volunteerId: String(payload?.volunteerId || ""),
        perDayAmount: String(payload?.perDayAmount || ""),
      };

      const res = await api.post(
        "/api/VolunteerAdmin/v1.0/addVolunteerCharges",
        body
      );

      if (res?.data?.responseCode === "00") {
        toast.success(res.data.responseMessage || "Inserted Successfully");

        onSuccess?.(res.data);

        return res.data;
      }

      if (shouldShowLocalError(res?.data)) {
        toast.error(res?.data?.responseMessage || "Failed to add charges");
      }

      return null;
    } catch (error) {
      console.error("addVolunteerChargesApi error:", error);
      toast.error("Error adding volunteer charges");
      return null;
    } finally {
      setVolunteerChargesLoading(false);
    }
  };

  /* ---------------- GET VOLUNTEER CHARGES ---------------- */

  const fetchVolunteerCharges = useCallback(
    async (volunteerCode = "", silent = false) => {
      if (!silent) setVolunteerChargesLoading(true);

      try {
        const body = {
          volunteerCode: String(volunteerCode || ""),
        };

        const res = await api.post(
          "/api/VolunteerAdmin/v1.0/getVolunteerCharges",
          body
        );

        if (res?.data?.responseCode === "00") {
          const charges = Array.isArray(res?.data?.data) ? res.data.data : [];

          setVolunteerCharges(charges);

          return charges;
        }

        if (shouldShowLocalError(res?.data)) {
          toast.error(res?.data?.responseMessage || "Failed to fetch charges");
        }

        setVolunteerCharges([]);
        return [];
      } catch (error) {
        console.error("fetchVolunteerCharges error:", error);
        toast.error("Error fetching volunteer charges");
        setVolunteerCharges([]);
        return [];
      } finally {
        if (!silent) setVolunteerChargesLoading(false);
      }
    },
    [api, AdminId]
  );

  return {
    volunteerCharges,
    setVolunteerCharges,
    volunteerChargesLoading,
    addVolunteerChargesApi,
    fetchVolunteerCharges,
    getVolunteerUserId,
  };
}